import { render, staticRenderFns } from "./formInputGroup.vue?vue&type=template&id=1536e978&"
import script from "./formInputGroup.vue?vue&type=script&lang=js&"
export * from "./formInputGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports